// extracted by mini-css-extract-plugin
var _1 = "ListingProfileWidgetPerformanceSkeleton-moduleListingProfileWidgetPerformanceSkeleton__cmjSP";
var _2 = "ListingProfileWidgetPerformanceSkeleton-modulelabel__eC3gL Skeleton-moduleSkeleton__Mlrfv";
var _3 = "ListingProfileWidgetPerformanceSkeleton-moduletile__qN520";
var _4 = "ListingProfileWidgetPerformanceSkeleton-modulevalue__hMuN5 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "ListingProfileWidgetPerformanceSkeleton", _2 as "label", _3 as "tile", _4 as "value" }
